export var defaultProps = {
    total: 0,
    current: 1,
    defaultCurrent: 1,
    pageSize: 10,
    sideCount: 3,
    prevText: '',
    nextText: '',
    ellipsisText: '...',
    onBeforeChange: function (page) { return true; },
    onChange: function (page) { },
};
